import React, { ComponentType, FC, PropsWithChildren, useRef } from 'react';
import { styled } from '@mui/system';
import { PopperPlacementType } from '@mui/material/Popper';
import Hint from '@/components/Hint';

export interface HintProps {
  hint?: string,
  showCondition?: (element: HTMLElement) => boolean;
  delay?: number;
  fadeDuration?: number;
  placement?: PopperPlacementType,
  hintDisabled?: boolean,
  bubbledEvents?: boolean,
  distance?: number,
};

const Content = styled('span')({
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '16px',
  letterSpacing: '0em',
  textAlign: 'left'
});

export default function <T>(Component: ComponentType<T>, defaults: HintProps): FC<T & HintProps & PropsWithChildren> {
  return ({ hint, showCondition, delay, placement, fadeDuration, hintDisabled, bubbledEvents, distance, ...props }: T & HintProps) => {
    const self = useRef<HTMLElement>(null);

    return (
      <>
        <Component {...props as T} ref={self} />
        <Hint
          anchor={self}
          delay={delay || defaults.delay}
          fadeDuration={fadeDuration || defaults.fadeDuration}
          placement={placement || defaults.placement}
          showCondition={showCondition || defaults.showCondition}
          disabled={hintDisabled}
          bubbledEvents={bubbledEvents}
          distance={distance || defaults.distance}
        >
          <Content>{hint || defaults.hint}</Content>
        </Hint>
      </>
    );
  };
}
